import { createContext } from 'react';

interface ThemeContextType {
  theme: 'light' | 'dark';
  setTheme?: (theme: 'light' | 'dark') => void;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
});

export default ThemeContext;
